





















import { SdsButtonIcon } from '@superbet-group/web.lib.ui-components';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'BetBuilderSummaryErrorMessage',
    props: {
        isDense: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['close'],
    components: {
        SdsButtonIcon,
    },
});
